import { render, staticRenderFns } from "./discrepancy-action-column.vue?vue&type=template&id=308145f4&scoped=true"
import script from "./discrepancy-action-column.vue?vue&type=script&lang=js"
export * from "./discrepancy-action-column.vue?vue&type=script&lang=js"
import style0 from "./discrepancy-action-column.vue?vue&type=style&index=0&id=308145f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308145f4",
  null
  
)

export default component.exports